<template>
<el-drawer title="花艺结算" :visible.sync="drawerVisible" size="80%" :append-to-body="true" :center="true" :wrapperClosable="false">
    <div class="hs-container" id="printTest">
        <el-table :data="detailsData" border show-summary>
            <el-table-column prop="supplier.title" label="供应商"></el-table-column>
            <el-table-column prop="category.title" label="花类品种"></el-table-column>
            <el-table-column prop="spec" label="品种级颜色"></el-table-column>
            <el-table-column label="品级">
                <template slot-scope="scope">
                    {{getTagTitle(scope.row.level)}}
                </template>
            </el-table-column>
            <el-table-column label="单位">
                <template slot-scope="scope">
                    <span v-if="scope.row.unit==1">把</span>
                    <span v-if="scope.row.unit==2">支</span>
                </template>
            </el-table-column>
            <el-table-column prop="count" label="数量"></el-table-column>
            <el-table-column prop="total" label="总价"></el-table-column>
        </el-table>
        <div class="footer-box" v-if="detailsData.length>0">
            <template>
                <div class="download">
                    <el-button type="primary" @click="submit">发起付款流程</el-button>
                </div>
            </template>
            <template v-if="type=='edit'">
                <div class="download">
                    <el-button type="primary" @click="editSubmit">重新发起付款流程</el-button>
                </div>
            </template>
            <div class="totals_box">
                <span>实际费用总价：{{totals.total}}</span>
            </div>
            <template v-if="row.item_check_status==2">
                <el-button type="primary" v-print="'#printTest'" @click="addPrint">打印</el-button>
                <el-button type="primary">临时修改</el-button>
            </template>
            <div class="totals_box" v-if="type=='edit' || type=='add'">
                <span>实际费用总价：{{totals}}</span>
            </div>

        </div>
    </div>
    <el-divider content-position="center">审核流程</el-divider>
    <!-- 审核流程 -->
    <div class="confirm-box" v-if="confirmStep.length > 0">
        <confirm-process :stepList="confirmStep" :confirm="confirm"></confirm-process>
    </div>
    <edit-view ref="editView"></edit-view>
</el-drawer>
</template>

<script>
import {
    showDrawerPass,
    objectSum
} from '@/utils/common.js';
import former from '@/utils/former.js';
import weddingUtils from '@/utils/wedding.js';
import editView from './edit.vue';
import confirmProcess from '@/components/audit/process'; // 新版审核流程
export default {
    components: {
        editView,
        confirmProcess
    },
    props: {
        parent: {}
    },
    data() {
        return {
            drawerVisible: false,
            detailsData: [],
            options: {},
            type: "",
            totals: {},
            confirm: {},
            confirmStep: [],
            row: {},
            labelList: [{
                id: 1,
                label: "A"
            }, {
                id: 2,
                label: "B"
            }, {
                id: 3,
                label: "C"
            }, {
                id: 4,
                label: "D"
            }],
            totals: {
                product_total: "",
                total: ""
            },
        }
    },
    beforeCreate() {
        this.showDrawerPass = showDrawerPass;
        this.former = former;
        this.getRuleTag = weddingUtils.getRuleTag;
        this.objectSum = objectSum;
    },
    methods: {
        showDrawer(query) {
            let _this = this;
            _this.drawerVisible = true;
            _this.query = query; // 搜索条件
            let url = '/api/wedding.settle/getBom';
            this.$post(url, {
                ..._this.query,
                ids: query.ids,
                type: "flower"
            }).then(function (res) {
                let resData = res.data;
                _this.detailsData = resData.bom
                _this.totals.total = objectSum(_this.detailsData, 'total');
                _this.getAuditResultAdd()
            });
        },
        // content: "1:把|2:支"
        // content: "1:A|2:B|3:C|4:D"
        getTagTitle(id) {
            let title = '';
            this.labelList.forEach((item) => {
                if (item.id == id) {
                    title = item.label;
                }
            });
            return title;
        },
        // 获取审核流程 添加
        getAuditResultAdd() {
            let _this = this;
            let url = '/api/order.audit/getAuditProcess';
            let params = {
                audit_type: "supplier_settle",
                order: {
                    company_id: _this.query.company_id,
                }

            };
            _this.$post(url, params).then(res => {
                if (res.code == 200) {
                    let auditProcess = res.data.process;
                    _this.confirmStep = auditProcess;

                }
            });

        },
        submit() {
            let _this = this;
            let url = '/api/wedding.settle/submit';
            let params = {
                ..._this.query,
                content: _this.detailsData,
                totals: _this.totals,
                type:"flower"
            };
            _this.$post(url, params).then((res) => {
                if (res.code == '200') {
                    _this.$message({
                        message: res.msg,
                        type: 'success'
                    });

                    _this.drawerVisible = false;
                    _this.parent.getTableData()
                } else {
                    _this.$message({
                        message: res.msg,
                        type: 'danger'
                    });
                }
            });
        },
        closeDrawer() {
            this.drawer.visible = false;
        }
    }
}
</script>

<style lang="less" scoped>
@import url('@/assets/css/common.less');

.totals_box {
    margin-left: 20px;
}

.attr-date,
.attr-select,
.attr-input,
.attr-remark {
    margin-right: 8px;
}

.attr-input,
.attr-select,
.attr-remark {
    width: 220px;
}

/************ 分割线 **************/
.box {
    display: flex;
    position: relative;
    height: 100vh;
    overflow: hidden;
    margin-top: 50px;

    .box-center {
        flex: 1;
        height: 100vh;
        overflow: auto;
        padding-bottom: 100px;
    }

    .box-comment {
        flex: 0 20%;
        height: 100vh;
        overflow: auto;
        padding: 12px;
        border-left: 1px solid #dedede;
    }
}

.fixed-btns {
    position: fixed;
    top: 55px;
    left: 0;
    z-index: 2000;
    height: 55px;
    line-height: 55px;
    width: 100%;
    text-align: right;
    padding-right: 24px;
    background: #f6f7fb;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 55px;
    width: 100%;
    text-align: right;
    padding-right: 24px;
    background: #f6f7fb;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding: 10px;
    line-height: 35px;
}

.selected-list {
    padding-left: 12px;
}

.selected-item {
    position: relative;
    cursor: pointer;

    .tree-title {
        padding: 8px;
        font-size: 14px;
        font-weight: 600;
    }

    .category-item {
        display: flex;
        border-top: 1px solid #dedede;

        .category-title {
            display: flex;
            width: 5rem;
            padding: 8px;
            align-items: center;
        }

        .category-rules {
            flex: 1;
            border-left: 1px solid #dedede;

            .category-item-form {
                padding: 8px;
                display: flex;

                .attr-date,
                .attr-select,
                .attr-textarea {
                    margin-right: 5px;
                    max-width: 120px;
                }

                .attr-input {
                    margin-right: 5px;
                    max-width: 120px;
                    min-width: 80px;
                }

                .attr-count {
                    margin-right: 5px;
                    width: 7rem;
                }

                .attr-remark {
                    margin-right: 5px;
                    flex: 1;
                }
            }
        }
    }

    .category-item:last-child {
        border-bottom: 1px solid #dedede;
    }

}

.selected-item:last-child {
    border-bottom: none;
}

/*** --------------------------------------- 分界线 ------------------------ ***/
.form-header {
    display: flex;
    padding: 12px;
    border-bottom: 1px solid #dedede;

    .form-submit {
        flex: 1;
        text-align: right;
    }
}

.main-demand {
    display: flex;

    .form-demand {
        flex: 1;
        padding-bottom: 20px;
    }

    .more-demand {
        flex: 0 25%;
        padding: 12px;
        border-left: 1px solid #dedede;
    }
}

.hs-table-pro {
    .hs-table-row {
        display: flex;
        border-top: .5px solid #f6f7fb;

        .hs-table-col {
            flex: 1;
            padding: 5px 8px;
            border-right: .5px solid #f6f7fb;
        }

        .hs-table-col.w120 {
            flex: 0 120px;
        }
    }

    .hs-table-row.hs-table-header {
        background: #f6f7fb;
        border-top: none;
    }
}

.selected-item {
    position: relative;
    cursor: pointer;

    .tree-title {
        padding: 8px;
        font-size: 14px;
        font-weight: 600;
    }

    .category-item {
        display: flex;
        border-top: 1px solid #dedede;

        .category-title {
            display: flex;
            width: 5rem;
            padding: 8px;
            align-items: center;
        }

        .category-rules {
            flex: 1;
            border-left: 1px solid #dedede;

            .category-item-form {
                padding: 8px;
                display: flex;

                .attr-date,
                .attr-select,
                .attr-textarea {
                    margin-right: 5px;
                    max-width: 120px;
                }

                .attr-input {
                    margin-right: 5px;
                    max-width: 120px;
                    min-width: 80px;
                }

                .attr-count {
                    margin-right: 5px;
                    width: 7rem;
                }

                .attr-remark {
                    margin-right: 5px;
                    flex: 1;
                }
            }
        }
    }

    .category-item:last-child {
        border-bottom: 1px solid #dedede;
    }

}

.selected-item:last-child {
    border-bottom: none;
}
</style>
